import { useEffect, useMemo, useRef, useState } from 'react';

const STORAGE_KEY = 'cj_audio_muted_v1';

function readStoredMuted() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === null) return true; // default muted
    return v === '1';
  } catch {
    return true;
  }
}

export function useAudioMute() {
  const audioRef = useRef(null);
  const [muted, setMuted] = useState(readStoredMuted);
  const [canPlay, setCanPlay] = useState(true);

  const api = useMemo(() => {
    return {
      muted,
      canPlay,
      toggle: async () => {
        const next = !muted;
        setMuted(next);
        try {
          localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
        } catch {
          // ignore
        }

        const audio = audioRef.current;
        if (!audio) return;

        audio.muted = next;
        audio.volume = next ? 0 : 0.7;

        if (!next) {
          try {
            await audio.play();
            setCanPlay(true);
          } catch {
            // Autoplay policy blocked or other errors
            setCanPlay(false);
            setMuted(true);
            audio.muted = true;
            audio.volume = 0;
            try {
              localStorage.setItem(STORAGE_KEY, '1');
            } catch {
              // ignore
            }
          }
        }
      }
    };
  }, [muted, canPlay]);

  useEffect(() => {
    const audio = new Audio('/time.mp3');
    audio.loop = true;
    audio.preload = 'auto';
    audio.muted = muted;
    audio.volume = muted ? 0 : 0.7;
    audioRef.current = audio;

    return () => {
      try {
        audio.pause();
      } catch {
        // ignore
      }
      audioRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return api;
}


